import React from "react";
import { Brain, Apple, Play, X } from "lucide-react";

const STORAGE_KEY = "gh_banner_dismissed_v1";

const AppBanner = () => {
  const [hidden, setHidden] = React.useState(
    typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY) === "1"
  );

  if (hidden) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setHidden(true);
  };

  return (
    <div
      className="relative bg-[color:var(--accent)] text-white border-b border-black/10"
      data-testid="generational-health-banner"
    >
      <div className="container-x flex items-center justify-between gap-4 py-2.5">
        <div className="flex items-center gap-3 min-w-0">
          <div className="hidden sm:grid place-items-center w-8 h-8 bg-black/20 shrink-0">
            <Brain size={14} />
          </div>
          <div className="min-w-0">
            <div className="font-mono text-[10px] uppercase tracking-widest opacity-80 hidden md:block">
              501(c)(3) · Mental Health
            </div>
            <div className="text-xs sm:text-sm font-semibold leading-tight truncate">
              Download <span className="font-display uppercase">Generational Health</span>
              <span className="hidden sm:inline"> — our mental health app</span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <a
            href="https://apps.apple.com/us/app/generational-health/id6751965153"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-black text-white text-[11px] font-mono uppercase tracking-widest hover:bg-white hover:text-black transition-colors"
            data-testid="banner-app-store-btn"
          >
            <Apple size={12} />
            <span className="hidden sm:inline">App Store</span>
            <span className="sm:hidden">iOS</span>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.generationalh.mobile.app&utm_source=na_Med"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-black text-white text-[11px] font-mono uppercase tracking-widest hover:bg-white hover:text-black transition-colors"
            data-testid="banner-play-store-btn"
          >
            <Play size={12} />
            <span className="hidden sm:inline">Google Play</span>
            <span className="sm:hidden">Android</span>
          </a>
          <button
            onClick={dismiss}
            aria-label="Dismiss banner"
            className="w-7 h-7 grid place-items-center hover:bg-black/20 transition-colors"
            data-testid="banner-dismiss-btn"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppBanner;
